import api from './api';

const supportService = {
    startChat:       (topic, message) => api.post('/support/chat/start', { topic, message }),
    connectChat:     (participantToken) => api.post('/support/chat/connect', { participantToken }),
    getTranscript:   (connectionToken, nextToken) => {
        const params = new URLSearchParams({ connectionToken });
        if (nextToken) params.append('nextToken', nextToken);
        return api.get(`/support/chat/transcript?${params.toString()}`);
    },
    sendMessage:     (connectionToken, message) => api.post('/support/chat/message', { connectionToken, message }),
    sendTypingEvent: (connectionToken) => api.post('/support/chat/event', { connectionToken }),
    endChat:         (connectionToken) => api.delete(`/support/chat?connectionToken=${encodeURIComponent(connectionToken)}`),
    // A page of the hub's documentation (Confluence space HHD), cleaned for display: { id, title, html, children,
    // parentId, version, updatedAt, url }. Links to other documentation pages carry data-doc-page-id.
    getDoc:          (pageId) => api.get(`/support/docs/${encodeURIComponent(pageId)}`),
};

export default supportService;
